var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandingFilled = function SvgBrandingFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    fill: "none",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M.015 9.947C.322 4.175 5.292-.293 11.065.015c5.622.3 10.232 4.704 9.983 9.942v.006c-.184 3.448-3.159 6.12-6.606 5.936-.227-.012-.453-.038-.68-.064-.286-.033-.572-.067-.861-.071-.464-.007-.674.077-.784.175-.239.215-.235.612-.083.78.678.752.763 1.924.34 2.816-.403.848-1.278 1.522-2.427 1.461C4.175 20.69-.293 15.72.015 9.946Zm8.762-4.184a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM4.007 9.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm9.245 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandingFilled);
export default ForwardRef;